export const ExtractBar = () => (
  <svg height="18" viewBox="0 0 19 18" width="19" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5906 15V16C17.5906 17.1 16.7157 18 15.6464 18H2.0373C0.95829 18 0.0931396 17.1 0.0931396 16V2C0.0931396 0.9 0.95829 0 2.0373 0H15.6464C16.7157 0 17.5906 0.9 17.5906 2V3H8.84185C7.76284 3 6.89769 3.9 6.89769 5V13C6.89769 14.1 7.76284 15 8.84185 15H17.5906ZM8.84185 13H18.5626V5H8.84185V13ZM12.7302 10.5C11.9233 10.5 11.272 9.83 11.272 9C11.272 8.17 11.9233 7.5 12.7302 7.5C13.537 7.5 14.1883 8.17 14.1883 9C14.1883 9.83 13.537 10.5 12.7302 10.5Z"
      fill="currentColor"
    />
  </svg>
)
